import styled from 'styled-components'

export const FormWrapper = styled.div`
  padding: 20px 30px 32px 30px;
`

export const FieldBox = styled.div`
  width: 230px;
`
